export default __webpack_public_path__ + "static/media/p9.8f48483b.png";